export const FootPage = () => {
  return (
    <div className="footPage">
      <div className="contentFoot">
        <div className="iteml">
          <div className="superior">
            <img src="./assets/img/logoblanco.png" alt="" />
            <div className="copyright">
              Complejo Arqueológico El Brujo &#169; 2021 <br />
            </div>
            <a href="https://www.elbrujo.pe/catalogo/admin" className="acceso" target="_blank" rel="noopener noreferrer">
              <ion-icon name="lock-closed-outline"></ion-icon>
              <b>Acceso privado</b>
            </a>
          </div>
          <div className="redes">
            <a href="https://www.youtube.com/channel/UC2RG2-Gxm6_6o7vDcTkrdZA" target="_blank" rel="noopener noreferrer">
              <ion-icon name="logo-youtube"></ion-icon>
            </a>
            <a href="https://twitter.com/elbrujope" target="_blank" rel="noopener noreferrer">
              <ion-icon name="logo-twitter"></ion-icon>
            </a>
            <a href="https://www.facebook.com/ComplejoArqueologicoElBrujo" target="_blank" rel="noopener noreferrer">
              <ion-icon name="logo-facebook"></ion-icon>
            </a>
            <a href="https://www.instagram.com/elbrujope/" target="_blank" rel="noopener noreferrer">
              <ion-icon name="logo-instagram"></ion-icon>
            </a>
          </div>
        </div>
        <div className="itemc">
          <div className="title">
            Enlaces El Brujo
          </div>
          <div className="listaEnlaces">
            <p>
              Visitantes
            </p>
            <p>
              Investigadores
            </p>
            <p>
              Estudiantes
            </p>
            <p>
              Comunidad
            </p>
            <p>
              Tienda Virtual
            </p>
          </div>
        </div>
        <div className="itemi">
          <div className="title">
            Informes
          </div>
          <div className="listaEnlaces">
            <b>Dirección</b>
            <p>
            Magdalena de Cao, provincia de Ascope, región La Libertad., a 60km al norte de Trujillo 13750
            </p>
            <b>Teléfono</b>
            <a href="tel:+51939326240">+51 939 326 240</a>
            <b>Correo</b>
            <a href="mailto:info@elbrujo.pe">info@elbrujo.pe</a>
          </div>
        </div>
      </div>
    </div>
  )
}
